var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Select',{attrs:{"clearable":_vm.clearable,"multiple":_vm.multiple},on:{"on-select":_vm.ddddd,"on-clear":_vm.clear},model:{value:(_vm.ddd),callback:function ($$v) {_vm.ddd=$$v},expression:"ddd"}},_vm._l((_vm.wanggeList),function(x,index){return _c('Option',{key:index,attrs:{"value":x.id}},[_vm._v(_vm._s(x.name))])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46633be6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/selectFence.vue
// module id = null
// module chunks = 